import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";
import SectionHeading from "./SectionHeading";

const TESTIMONIALS = [
  {
    quote: "Down 2 dress sizes in 60 days!",
    name: "Client Transformation",
    meta: "Received on WhatsApp",
    highlight: true,
  },
  {
    quote: "No weakness or starving.",
    name: "Client Transformation",
    meta: "Received on WhatsApp",
    highlight: false,
  },
  {
    quote: "Chronic acidity gone, 8-year migraine under control, deep restful sleep.",
    name: "Snehal, Pune",
    meta: "IT Professional · 66 kg to 56 kg",
    highlight: false,
  },
];

export default function Testimonials() {
  return (
    <section className="relative py-24 lg:py-32">
      <div
        aria-hidden="true"
        className="absolute top-10 left-1/4 h-80 w-80 rounded-full bg-accent/8 blur-[120px]"
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <SectionHeading
          eyebrow="Testimonials"
          title="What Clients Say"
          sub="Unedited messages and health wins from real coaching journeys — the kind of feedback that can't be bought."
        />
        <div className="mt-14 grid md:grid-cols-3 gap-6 items-stretch">
          {TESTIMONIALS.map((t, i) => (
            <motion.div
              key={t.quote}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className={`relative flex flex-col rounded-3xl border p-8 transition-all duration-300 hover:-translate-y-1.5 ${
                t.highlight
                  ? "border-gold/40 bg-gradient-to-br from-gold/10 via-panel to-panel hover:shadow-glow-gold"
                  : "border-line bg-panel hover:border-accent/50 hover:shadow-glow-emerald"
              }`}
              data-testid={`testimonial-card-${i}`}
            >
              <Quote className={`h-8 w-8 ${t.highlight ? "text-gold" : "text-emerald-400/70"}`} />
              <div className="mt-4 flex gap-1">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-gold text-gold" data-testid={`testimonial-star-${i}-${s}`} />
                ))}
              </div>
              <p className="mt-5 flex-1 font-display text-xl sm:text-2xl font-bold leading-snug text-white">
                "{t.quote}"
              </p>
              <div className="mt-7 pt-5 border-t border-line">
                <p className="text-sm font-bold text-white">{t.name}</p>
                <p className="mt-0.5 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{t.meta}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
          className="mt-8 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-slate-600"
          data-testid="testimonials-note"
        >
          Real messages. Real clients. Zero scripts.
        </motion.p>
      </div>
    </section>
  );
}